import {defineRule} from 'vee-validate';

defineRule('validPhoneNumber', (value) => {
    return value.full === null || value.isValid || (value && value.isValid === undefined);
});

defineRule('requiredPhoneNumber', (value) => {
    return value !== null && value.full !== null && value.full !== '';
});
